<template>
  <div>
    <div
      class="strategy"
      v-html="strategy"
    ></div>
    <van-icon
      name="close"
      class="close"
      @click="closeWebAgreement"
    />
    <div
      class="bottom"
      id="bottom"
    ></div>
    <div class="fix">
      <van-button
        type="default"
        block
        :disabled="disabled"
        class="btn"
        @click="surePay"
      >
        {{disabled ? scroller ? "请上滑看完本协议再同意" : `同意本协议（${second}s）` : "同意本协议"}}
      </van-button>
    </div>
  </div>
</template>

<script>
import { getActivityRuleContent } from "@/api/join";
export default {
  data() {
    return {
      strategy: "",
      show: true,
      disabled: true,
      second: 5, // 秒
      scroller: false, // 是否有滚动条
    };
  },
  methods: {
    closeWebAgreement() {
      // 调用APP方法
      // 关闭弹窗
      if (this.$store.getters.ambientType == 1) {
        window.Android.closeWebAgreement();
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.closeWebAgreement.postMessage("");
      }
    },
    surePay() {
      // 调用APP方法
      // 关闭弹窗并且支付
      if (this.$store.getters.ambientType == 1) {
        window.Android.surePay();
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.surePay.postMessage("");
      }
    },
    countdown(intersectionObserver) {
      // 倒计时
      let timer = setInterval(() => {
        this.second = this.second - 1;
        if (this.second == 0) {
          this.disabled = false;
          clearInterval(timer);
          // 关闭观察器
          intersectionObserver.disconnect();
        }
      }, 1000)
    },
    observer() {
      // 初始化观察对象
      let intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) {
          // 一开始看不见，就说明有滚动条
          this.scroller = true;
        } else {
          if (this.scroller) {
            // 滚动到底部了
            this.scroller = false;
            this.countdown(intersectionObserver);
          } else {
            this.countdown(intersectionObserver);
          }
        }
      });

      // 开始观察
      intersectionObserver.observe(
        document.getElementById('bottom')
      );
    }
  },
  mounted() {
    getActivityRuleContent({ type: "20" }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.strategy = res.content.content;
        this.observer();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.strategy {
  padding: 16px 25px 0 20px;
}
.close {
  position: absolute;
  top: 24px;
  right: 25px;
  font-size: 18px;
  color: #b2b2b2;
}
.fix {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}
.bottom {
  height: 70px;
}
.btn {
  width: 345px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  color: #ffffff;
  background: linear-gradient(to right, #FB6A4A 0%, #FF0808 100%);
  border-radius: 25px;
}
</style>